var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zwbs"},[_c('div',{staticClass:"banner"}),_c('keep-alive',[_c('router-view')],1),_c('BottomTabbar',{attrs:{"tabs":_vm.option.tabs,"themeColor":_vm.option.themeColor}}),_c('div',{staticStyle:{"height":"50px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }